import { DynamicContext } from '@dynamic-labs/sdk-react-core'
import {
	TypographyDisplay,
	TypographyLabel,
	TypographyParagraph,
} from '../components/typography'
import CollectionAdd, {
	CollectionAddNFTsComponent,
	CollectionDetailsComponent,
} from '../components/collectionAdd/collectionAdd'
import { Button } from '../components/buttons'
import { WalletIcon } from '../components/icons'
import BackButton from '#app/components/common/backButton'
import CertifyIcon from '#app/components/icons/Miscellaneous/CertifyIcon'
import { useTheme } from '#app/utils/providers/themeProvider'
import { json, LoaderFunctionArgs, redirect } from '@remix-run/node'
import { useLoaderData } from '@remix-run/react'
import { getSession } from '#app/utils/sessions.js'
import {
	fetchDynamicUser,
	getMappedAndFilteredDynamicUsersForEnrichnment,
} from '#app/utils/dynamic.server.js'
import { createToastHeaders } from '#app/utils/toast.server.js'

export async function loader({ request }: LoaderFunctionArgs) {
	const url = new URL(request.url)
	const origin = url.origin
	const envOrigin = import.meta.env.VITE_APP_URL
	const session = await getSession(request.headers.get('cookie'))
	const sessionUserId = session.get('userId')
	const referrer =
		request.headers.get('referer') ??
		request.headers.get('referrer') ??
		request.referrer

	let headers: Headers
	if (sessionUserId) {
		try {
			const dynamicUser = await fetchDynamicUser({ userId: sessionUserId })
			if (
				dynamicUser &&
				dynamicUser.metadata &&
				dynamicUser.metadata.accessLevel &&
				dynamicUser.metadata.accessLevel.createCollection
			) {
				// get all DynamicUsers
				const users = await getMappedAndFilteredDynamicUsersForEnrichnment()
				return json({ atomicLoreUrl: origin || envOrigin, users })
			} else {
				headers = await createToastHeaders({
					title: 'Unable to load Collection Add Page',
					description: 'User does not have create collection access',
				})
			}
		} catch (e) {
			console.error('ERROR FETCHING DYNAMIC USER FOR', sessionUserId)
			headers = await createToastHeaders({
				title: 'Unable to load Collection Add Page',
				description: 'Failed retrieving user from dynamic',
			})
		}
	} else {
		headers = await createToastHeaders({
			title: 'Unable to load Collection Add Page',
			description: 'User does not have an active session',
		})
	}

	if (origin && referrer && referrer.includes(origin)) {
		throw redirect(referrer, { headers })
	} else {
		throw redirect('/', { headers })
	}
}

export default function collectionAdd() {
	const { atomicLoreUrl, users } = useLoaderData<typeof loader>()
	const [theme] = useTheme()
	return (
		<div className="h-full w-full px-4 py-16 md:px-12 lg:px-36">
			{!DynamicContext._currentValue ? (
				<div className="flex w-full flex-col items-center justify-center">
					<div className="w-full max-w-[1148px]">
						<>
							<BackButton />
							<div className="mb-20 mt-9 flex flex-col justify-between md:flex-row">
								<div className="flex flex-col">
									<TypographyLabel
										size="small"
										additionalClasses="text-textSecondaryLight dark:text-textSecondaryDark"
									>
										ATOMIC LORE
									</TypographyLabel>
									<div className="my-2 flex">
										<TypographyDisplay
											size="medium"
											additionalClasses="font-rapidSpecial text-textPrimaryLight dark:text-textPrimaryDark"
										>
											Create Collection
										</TypographyDisplay>
										<CertifyIcon />
									</div>
									<TypographyParagraph
										size="medium"
										additionalClasses="text-textSecondaryLight dark:text-textSecondaryDark"
									>
										By creating and signing Collections in Atomic Lore, you can
										build a verified onchain archive of your artwork.
									</TypographyParagraph>
								</div>
								<div className="flex flex-col items-end justify-end">
									{/* {!isAuthenticated && ( */}
									<Button
										variant="secondary"
										disabled={true}
										rightIcon={<WalletIcon />}
										onClick={() => {}}
									>
										Loading...
									</Button>
									{/* )} */}
								</div>
							</div>
						</>
						<CollectionAddNFTsComponent
							theme={theme}
							formData={{}}
							errorFields={{}}
							handleFormDataChange={() => {}}
						/>
						<CollectionDetailsComponent
							users={users}
							theme={theme}
							formData={{}}
							missingRequiredFields={[]}
							errorFields={{}}
							handleFormDataChange={() => {}}
						/>
					</div>
					<div className="mt-8 flex flex-row gap-x-4">
						<div className="flex w-0 flex-col md:w-2/5">
							<div className="w-full" />
							{/*<TypographyHeading size="small" additionalClasses="text-textPrimaryLight dark:text-textPrimaryDark">3. Store and sign</TypographyHeading>*/}
						</div>
					</div>
					{/* <TypographyDisplay size="medium">Loading Collection Sign Page</TypographyDisplay>
                    <Loader size="large" /> */}
				</div>
			) : (
				<div className="flex w-full flex-col items-center justify-center">
					<CollectionAdd atomicLoreUrl={atomicLoreUrl} users={users} />
				</div>
			)}
		</div>
	)
}
